import QuestionTextField from "./QuestionTextField";
import {NassauLog} from "../../scripts/myga-utils";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {MM_QUESTION} from "../../scripts/myga-model";

const QuestionCurrency = props => {
  const {handleChange, data, question, responseClass, required} = props;
  const constraints = question.response[MM_QUESTION.response.constraints][0] || {};
  const {decimalsEnabled, decimalPlaces} = constraints;
  const [displayValue, setDisplayValue] = useState('');
  const [value, setValue] = useState(data[question.key] ? data[question.key] : '');
  const firstRender = useRef(true);
  const currencyOptions = useMemo(() => {
    return decimalsEnabled ? {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    } : {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  }, [decimalPlaces, decimalsEnabled])
  
  useEffect(() => {
    let vs = parseInt(value);
    let formattedValue = '';
    if (!Number.isNaN(vs)) {
      formattedValue = vs.toLocaleString('en-US', currencyOptions);
    }
    setDisplayValue(formattedValue);
  }, [currencyOptions, value]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    handleChange(question.key)(value);
  }, [value, handleChange, question.key])

  const currencyHandleChange = useCallback((key='') => e => {
    // remove formatting including trailing decimals.
    setValue(e.target.value.replace(/[^.\d]/g,'').replace(/\.\d+/,''));
  },[]);

  const onKeyDown = useCallback(e => {
    // Skip de-formatting for Enter, Select, Tab and Arrow keys
    // Also skip when text is selected
    if (e.keyCode === 13 || e.keyCode === 9 || e.keyCode === 37 ||
        e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 16)
      return

    // Remove entire string if deleting final non-formatting digit
    if ((e.keyCode === 8 || e.keyCode === 46) && e.target.value.length === 5) {
        e.target.value = '';
        return
    }

    if (window.getSelection().toString().length > 0) {
      if (e.target.selectionEnd > e.target.value.lastIndexOf('.'))
        e.target.selectionEnd = e.target.value.lastIndexOf('.')
      return
    }

    // Skip de-formatting for backspace
    if (e.keyCode === 8) {
      // Move the cursor to the . if cursor position is to the right of the .
      if (e.target.selectionStart > e.target.value.lastIndexOf('.')) {
        e.target.selectionStart = e.target.value.lastIndexOf('.');
        e.target.selectionEnd = e.target.selectionStart;
      }
      return
    }

    // Remove formatting including trailing decicmals before processing keyup
    e.target.value = parseInt(e.target.value.replace(/[^.\d]/g, '').replace(/\.\d+/,''))
  }, []);

  return <QuestionTextField {...props}
                            value={displayValue}
                            handleChange={currencyHandleChange}
                            handleKeyDown={onKeyDown}
                            required={required}
                            responseClass={responseClass}/>
}

export default QuestionCurrency;